export const iconFontAwesomeMedicalHealthShieldVirus = (
	<i className="fa-solid fa-shield-virus"></i>
);
